import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'src/app/services/dialog.service';
import { MangeStadisticsService } from 'src/app/services/manage-stadistics.service';
import { OpentokService } from 'src/app/services/opentok.service';
import { VideoconsultaBackendService } from 'src/app/services/videoconsulta-backend.service';
import { PopupBody } from 'src/app/types/PopupBody';
import { clearLocalStorage, clearTimer } from 'src/app/utils/utils';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css'],
})
export class PopupComponent implements OnInit {
  title: string;
  body: string;
  btns: string[];
  link: string;

  constructor(
    private _dialog: DialogService,
    private _opentok: OpentokService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: PopupBody,
    private _videoconsulta: VideoconsultaBackendService,
    private _stadistics: MangeStadisticsService,
    private _spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    const { title, body, btns, link } = this.data;
    this.title = title;
    this.body = body;
    this.btns = btns;
    this.link = link;
  }

  async finalizarVC(): Promise<void> {
    const { cid, isMedic } = this.data;

    this._spinner.show();
    this._dialog.closeDialog();

    if (isMedic) {
      try {
        await this._videoconsulta.blacklistCid(cid).toPromise();
        clearTimer();
        clearLocalStorage();
        await this.endCall('medico', cid, isMedic);
      } catch (err) {
        console.error(err);
      }
    } else {
      await this.endCall('socio', cid, isMedic);
    }
  }

  async endCall(
    user: 'medico' | 'socio',
    cid: number,
    m: number
  ): Promise<void> {
    await this._stadistics
      .sendStatistics('final', { streamfinished: user })
      .catch((err) => console.log(err));
    if (this._opentok.suscriber) this._opentok.session.unsubscribe(this._opentok.suscriber);
    this._opentok.session.unpublish(this._opentok.publisher);
    this._opentok.session.disconnect();
    this._spinner.hide();
    this.router.navigate(['/finalizado'], { state: { cid, m } });
  }

  closePopup(): void {
    this._dialog.closeDialog();
    history.pushState(null, '', location.href);
  }
}
